if(!customElements.get('variant-dropdown')) {
  class VariantDropdown extends HTMLElement {
    constructor() {
      super();
    }
    
    handleModalInput(optionId, value) {
      if(!this.masterSelect) return;

      let selector = 'option';

      this.variantDropdowns.forEach((dropdown, index) => {
        selector += `[data-js-option-${index + 1}="${dropdown.dataset.value}"]`;
      });

      const selectedOption = this.masterSelect.querySelector('option[selected]');
      const newOption = this.masterSelect.querySelector(selector);

      if(newOption.getAttribute('value') == selectedOption.getAttribute('value')) return;

      selectedOption.removeAttribute('selected');
      newOption.setAttribute('selected', '');

      this.masterSelect.selectedIndex = Number(newOption.getAttribute('data-js-option-index'));
      this.masterSelect.setAttribute('value', newOption.getAttribute('value'));
      this.addToCart.update(newOption.getAttribute('value'), newOption.getAttribute('data-js-available'));
    }

    initValueElements() {
      if(!this.valueElements.length) return;
      
      this.valueElements.forEach(element => {
        element.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopImmediatePropagation();
          
          const value = element.getAttribute('data-value');

          this.trigger.setAttribute('data-value', value);
          this.setAttribute('data-value', value);

          this.currentValue.innerHTML = element.innerHTML;

          this.dropdownBody.classList.remove('is-active');
          this.trigger.classList.remove('is-active');

          if(element.hasAttribute('data-variant-available') && element.hasAttribute('data-variant-id')) {
            const modal = document.querySelector(`js-modal-${element.dataset.productId}`);
            let addToCart;
            if(modal) addToCart = modal.querySelector('.product-modal__add');
            if(addToCart) addToCart.update(element.getAttribute('data-variant-id'), element.getAttribute('data-variant-available'), element.getAttribute('data-variant-price'));
          }

          this.productForm.setVariant(this.optionId, value);
        });
      });
    }

    close() {
      this.dropdownBody.classList.remove('is-active');
      this.trigger.classList.remove('is-active');
    }

    connectedCallback() {
      this.productForm = this.closest('product-form');
      this.trigger = this.querySelector('.js-variant-dropdown-trigger');
      this.currentValue = this.querySelector('.js-selected-option');
      this.dropdownBody = this.querySelector('.js-variant-dropdown-body');
      this.valueElements = this.querySelectorAll('.js-option-change');
      this.optionId = this.getAttribute('data-option-id');
      this.isModal = this.getAttribute('data-is-modal') == "true" ? true : false;
      if(this.isModal) {
        this.modal = this.closest('modal-dialog');
        this.addToCart = this.modal.querySelector('cart-add');
        this.masterSelect = this.modal.querySelector('.js-master-input');
        this.variantDropdowns = this.modal.querySelectorAll('variant-dropdown');
      }

      if(!this.trigger || !this.dropdownBody) return;

      document.body.addEventListener('click', (event) => {
        this.close();
      });

      this.trigger.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();

        const dropdowns = document.querySelectorAll('variant-dropdown');
        dropdowns.forEach((dropdown) => {
          if(dropdown != this) dropdown.close();
        });

        // const height = window.innerHeight;
        // const dropdownTop = this.getBoundingClientRect().top;

        // this.dropdownBody.style.maxHeight = `${height - dropdownTop - 160}px`;
        this.dropdownBody.classList.toggle('is-active');
        this.trigger.classList.toggle('is-active');
      });

      this.initValueElements();
    }
  }

  customElements.define('variant-dropdown', VariantDropdown);
}
